module.exports = __webpack_public_path__ + "img/28.4cceed90.svg";